<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (min-width: @max-screen)
{
  *{margin: 0;list-style-type:none;}
  .center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
  .periodical{width: 1150px; margin: 0px auto; display: flex;flex-direction: column;margin-bottom: 20px;}
  i{float: left;margin-top: -1px;margin-right: 8px;font-size: 20px;color: rgb(25, 159, 248);}
  .logo{align-self: start;margin-top: 20px;
    span{font-size: 18px;color: rgb(49, 49, 49);}
  }
  .main{width: 1130px; margin: 0px auto; margin-left: 20px; display: flex;flex-direction: column;margin-bottom: 20px;}
  .type{margin-top: 20px;margin-bottom:20px;
    .left{float: left;
      span{font-size: 18px;font-weight: 600;}}
    .right{float: right;cursor: pointer;
      span{font-size: 16px;font-weight: 600;color: rgb(17, 17, 17);}
      img{vertical-align: bottom;}
    }
  }
  ul{list-style: none;
    li{display: flex;margin-left: -40px;height: 100px;}
    li:last-child{border-bottom: 2px solid rgb(223, 222, 222);}
    li:hover{cursor: pointer;.title{color:rgb(53, 132, 196);}}
    img{width: 100px;height:80px;margin-right: 20px;}
    p{margin-top: 30px;white-space: nowrap; overflow: hidden; text-overflow:ellipsis;}
    .title{width: 420px;text-align: left;margin-right: 40px;}
    .author{width: 300px;text-align: left;margin-right: 40px;}
    .pdf{width: 60px;margin-right: 60px;margin-top: 33px;}
  }
}
@media screen and (max-width: @max-screen){
  *{margin: 0;list-style-type:none;padding: 0;}
  .center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
  .periodical{width: 98%; margin: 0px auto; display: flex;flex-direction: column;margin-bottom: 20px;}
  i{float: left;margin-top: -1px;margin-right: 8px;font-size: 20px;color: rgb(25, 159, 248);}
  .logo{align-self: start;margin-top: 20px;
    span{font-size: 18px;color: rgb(49, 49, 49);}
  }
  .main{width: 100%; margin: 0px auto; display: flex;flex-direction: column;margin-bottom: 20px;}
  .type{margin-top: 20px;margin-bottom:20px;
    .left{float: left;
      span{font-size: 18px;font-weight: 600;}}
    .right{float: right;cursor: pointer;
      span{font-size: 16px;font-weight: 600;color: rgb(17, 17, 17);}
      img{vertical-align: bottom;}
    }
  }
  ul{list-style: none;
    li{display: flex;height: 100px;}
    li:last-child{border-bottom: 2px solid rgb(223, 222, 222);}
    li:hover{cursor: pointer;.title{color:rgb(53, 132, 196);}}
    img{width: 25%;height:80px;}
    p{white-space: nowrap; overflow: hidden; text-overflow:ellipsis;}
    .title{width: 72%;height:100%;text-align: left;margin-left: 3%;white-space: normal;overflow: auto;word-wrap: break-word;display: flex;align-items: flex-start;}
  }
}
</style>

<template>
  <div class="center">
    <div class="periodical">
      <div class="logo">
        <i class="iconfont icon-zixun"></i><span>东盟地学</span>
      </div>
      <div class="main">
        <div class="type">
          <div class="left">
            <span>地球科学</span>
          </div>
          <div class="right" @click = getMore(DQKX)>
            <span>查看更多</span>
            <img src="static/images/zlkindex/arrow.png" />
          </div>
        </div>
        <ul class="catalogue">
          <li v-for="(item, index) in dqkxList" :key="index" @click="lookPDF(item.pdf)">
            <img v-if="item.thumb !== ''"  :src="item.thumb" />
            <img v-if="item.thumb === ''"  src="static/images/moren.jpg" />
            <p class="title">{{ item.title }}</p>
            <p class="author" v-if='ifShowFlag'>{{ item.author }}</p>
            <p class="pdf"  v-if='ifShowFlag'><i class="iconfont icon-pdf" style="color: #FF5562"></i>PDF</p>
            <p class="time"  v-if='ifShowFlag'>{{ item.addtime * 1000 | formatDateYM() }}</p>
          </li>
        </ul>
        <div class="type">
          <div class="left">
            <span>矿产调查</span>
          </div>
          <div class="right" @click = getMore(KCDC)>
            <span>查看更多</span>
            <img src="static/images/zlkindex/arrow.png" />
          </div>
        </div>
        <ul class="catalogue">
          <li v-for="(item, index) in kcdcList" :key="index" @click="lookPDF(item.pdf)">
            <img v-if="item.thumb !== ''"  :src="item.thumb" />
            <img v-if="item.thumb === ''"  src="static/images/moren.jpg" />
            <p class="title">{{ item.title }}</p>
            <p class="author"  v-if='ifShowFlag'>{{ item.author }}</p>
            <p class="pdf"  v-if='ifShowFlag'><i class="iconfont icon-pdf" style="color: #FF5562"></i>PDF</p>
            <p class="time"  v-if='ifShowFlag'>{{ item.addtime * 1000 | formatDateYM() }}</p>
          </li>
        </ul>
        <div class="type">
          <div class="left">
            <span>典型矿床</span>
          </div>
          <div class="right" @click = getMore(DXKC)>
            <span>查看更多</span>
            <img src="static/images/zlkindex/arrow.png" />
          </div>
        </div>
        <ul class="catalogue">
          <li v-for="(item, index) in dxkcList" :key="index" @click="lookPDF(item.pdf)">
            <img v-if="item.thumb !== ''"  :src="item.thumb" />
            <img v-if="item.thumb === ''"  src="static/images/moren.jpg" />
            <p class="title">{{ item.title }}</p>
            <p class="author"  v-if='ifShowFlag'>{{ item.author }}</p>
            <p class="pdf"  v-if='ifShowFlag'><i class="iconfont icon-pdf" style="color: #FF5562"></i>PDF</p>
            <p class="time"  v-if='ifShowFlag'>{{ item.addtime * 1000 | formatDateYM() }}</p>
          </li>
        </ul>
        <div class="type">
          <div class="left">
            <span>生态地质</span>
          </div>
          <div class="right" @click = getMore(STDZ)>
            <span>查看更多</span>
            <img src="static/images/zlkindex/arrow.png" />
          </div>
        </div>
        <ul class="catalogue">
          <li v-for="(item, index) in stdzList" :key="index" @click="lookPDF(item.pdf)">
            <img v-if="item.thumb !== ''"  :src="item.thumb" />
            <img v-if="item.thumb === ''"  src="static/images/moren.jpg" />
            <p class="title">{{ item.title }}</p>
            <p class="author"  v-if='ifShowFlag'>{{ item.author }}</p>
            <p class="pdf"  v-if='ifShowFlag'><i class="iconfont icon-pdf" style="color: #FF5562"></i>PDF</p>
            <p class="time"  v-if='ifShowFlag'>{{ item.addtime * 1000 | formatDateYM() }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 东盟地学 罗志远
 */
import filters from '../method/filter'
export default {
  name: '',
  mixins: [filters],
  data()
  {
    return {
      dqkxList: [], //地球科学
      kcdcList: [], //矿产调查
      dxkcList: [], //典型矿床
      stdzList: [], //生态地质
      DQKX: 423,
      KCDC: 424,
      DXKC: 425,
      STDZ: 432,
      ifShowFlag: true
    }
  },
  created()
  {
    this.getData()
  },

  mounted()
  {
    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },

  methods:
  {
    //获取数据
    getData()
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 66, _exp: 'catid=423 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras1).then((ret) =>
      {
        this.dqkxList = ret[0].data
      })
      let paras2 = {cmd: 'query', _major: 11, _minor: 66, _exp: 'catid=424 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras2).then((ret) =>
      {
        this.kcdcList = ret[0].data
      })
      let paras3 = {cmd: 'query', _major: 11, _minor: 66, _exp: 'catid=425 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras3).then((ret) =>
      {
        this.dxkcList = ret[0].data
      })
      let paras4 = {cmd: 'query', _major: 11, _minor: 66, _exp: 'catid=432 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras4).then((ret) =>
      {
        this.stdzList = ret[0].data
      })
    },
    //查看更多
    getMore(num)
    {
      let url = this.$router.resolve({path: '/DMgeoList', query: {catid: num}})
      window.open(url.href, '_blank')
    },
    //查看pdf文件
    lookPDF(url)
    {
      // if (localStorage.getItem('username'))
      window.open(url, '_blank')
      // else
      //   this.$message({message: '请先登录后再查看文件内容', type: 'error', customClass: 'mzindex'})
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/plugins/app/project/Dmgeonomy.vue